import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`;

export const FormTitle = styled.h2`
  font-size: ${32 / 16}rem;
  color: rgb(102, 102, 102);
  text-align: center;
  font-weight: bold;
  margin-top: 32px;
`;

export const FormParagraph = styled.p`
  text-align: center;
  color: rgb(102, 102, 102);
  margin-top: 8px;
`;

export const FormWrapper = styled.form`
  max-width: 90%;
  margin: auto;
  gap: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Wrapper = styled.div`
  width: 100%;
  margin-top: 32px;
  max-height: 56vh;
  overflow: auto;
  padding-right: 8px;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const GroupSection = styled.section`
  width: 100%;
`;

export const GroupTitle = styled.h3`
  margin: 0 0 12px;
  font-size: ${14 / 16}rem;
  font-weight: 700;
  color: #333;
`;


export const FieldsGrid = styled.div`
  display: grid;
  gap: 16px;

  grid-template-columns: repeat(3, minmax(0, 1fr));

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldCard = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  padding: 14px;
  background: #fff;
`;

/* Layout do campo + categoria (admin) */
export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 180px;
  gap: 12px;
  align-items: end;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const CategoryBox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CategoryLabel = styled.label`
  font-size: ${12 / 16}rem;
  font-weight: 500;
  color: #666;
  margin-bottom: 6px;
`;

export const CategoryInput = styled.input`
  height: 40px;
  border-radius: 10px;
  border: 1px solid #d8d8d8;
  padding: 0 10px;
  outline: none;

  &:focus {
    border-color: #6ea6ff;
  }
`;

export const ButtonsWrapper = styled.div`
  gap: 16px;
  display: flex;
  justify-content: center;
  min-width: 80%;
`;

export const StepBtn = styled.button`
  width: 35%;
  border-radius: 2rem;
  padding: 12px;
  font-weight: 500;
  font-size: ${14 / 16}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  & svg {
    min-width: ${16 / 16}rem;
    min-height: ${16 / 16}rem;
  }
`;

export const BackBtn = styled(StepBtn)`
  border: 1px solid #b6b6b6;
  color: #606060;
`;

export const SendBtn = styled(StepBtn)`
  border: 1px solid #dd6435;
  color: #fff;
  background-color: #dd6435;
  svg {
    margin-left: 8px;
  }
`;

export const ForwardBtn = styled(StepBtn)`
  border: 1px solid #6ea6ff;
  color: #fff;
  background-color: #6ea6ff;
  svg {
    margin-left: 8px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const CategoryPillButton = styled.button`
  border: 1px solid #e6e6e6;
  background: #fafafa;
  color: #444;
  border-radius: 999px;
  height: 34px;
  padding: 0 10px;

  display: inline-flex;
  align-items: center;
  gap: 8px;

  cursor: pointer;

  /* evita quebrar o layout em cards estreitos */
  max-width: 100%;

  span {
    display: inline-block;
    max-width: 140px;     /* ajuste fino */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
  }

  svg {
    flex: 0 0 auto;
  }

  &:hover {
    background: #f3f3f3;
  }
`;

export const CategoryEditor = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #efefef;
`;

export const CategoryEditorLabel = styled.label`
  font-size: ${12 / 16}rem;
  font-weight: 600;
  color: #666;
  display: block;
  margin-bottom: 6px;
`;

export const CategoryEditorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CategoryEditorInput = styled.input`
  flex: 1;
  height: 38px;
  border-radius: 10px;
  border: 1px solid #d8d8d8;
  padding: 0 10px;
  outline: none;
  min-width: 0;

  &:focus {
    border-color: #6ea6ff;
  }
`;

export const IconBtn = styled.button`
  height: 38px;
  width: 38px;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f7f7f7;
  }
`;

export const CardTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
`;

export const FieldName = styled.div`
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #222;

  flex: 1;
  min-width: 0;

  white-space: normal;
  overflow: visible;
  text-overflow: unset;

  /* ajuda em palavras gigantes sem espaço */
  overflow-wrap: anywhere;
  word-break: break-word;

  line-height: 1.2;
`;

export const InputOnly = styled.div`
`;

export const PopoverOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
`;

export const CategoryPopover = styled.div`
  position: absolute;
  width: 320px;
  max-width: calc(100vw - 24px);
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  padding: 12px;
`;

